module.exports = __webpack_public_path__ + "img/Wassermassen.a7f5ad8b.svg";